import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, ElementRef, PLATFORM_ID, ViewChild, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray, UntypedFormControl } from '@angular/forms';
import { CoreLookUpService } from 'src/app/services/feature/kb-my-cores/kbMyCores.service';
import { MatDialog } from '@angular/material/dialog';
import { RegisterService } from 'src/app/services/feature/register.service';
import { CoreDialogComponent } from './core-dialog/core-dialog.component';
import { GlobalMessageService, GlobalMessageType, OccEndpointsService } from '@spartacus/core';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { FileDownloadService } from '@spartacus/storefront';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, Subscription, combineLatest, from, of } from 'rxjs';
import { filter, mergeMap, takeUntil } from 'rxjs/operators';
//import * as Papa from 'papaparse';
import { parse } from 'csv-parse/browser/esm';
const CORE_GRADE = 'Core Grade*';
const CORE_GROUP = 'Core Group*';
const CORE_CLASS = 'Core Class*';
@Component({
  selector: 'app-kb-myCores',
  templateUrl: './kb-myCoreSubmit.component.html',
  styleUrls: ['./kb-myCoreSubmit.component.scss'],
  standalone: false
})
export class KbMyCoreSubmitComponent {
  [x: string]: any;
  productTypeArray: any;
  addressListArray: any;
  countryDataArray: any;
  stateDataArray: any;
  downLoadUrl: string;
  baseUrl: string;
  sapcustomerid: any;
  Apidata: any;
  coreClass: any[] = [];
  coreUpgradeClass: any[] = [];
  weight: any;
  transportNeeded: boolean = true;
  apiloaded: boolean = false;
  showChild: boolean = false;
  showTextBox: boolean = false;
  showUnder500: boolean = true;
  notDisplay: boolean = false;
  screenWidth: number;
  widthPercentage = 67;
  isMobile: boolean = false;
  UserCrmForm: boolean = false;
  //pagestatus error messages
  isFormContainsError: boolean = false;
  isFormFilledSuccessfully: boolean = false;
  submittedSuccessFully: boolean = false;
  @ViewChild('confirmSubmitPopup') confirmSubmitPopup: any;
  @ViewChild('fileInput') fileInputRef: ElementRef;
  crmStaticKepper: string = '';
  selectedFile: File;
  dataFrom: boolean = false;
  savedSuccessfully: boolean = false;
  barCodeLabel: any;
  selectedPopupIndex: any;
  csvFileListLength = 0;
  errorMsgList: any;
  fileUploadMsg: any;
  addToCoreFormSubscriber: Subscription;
  currentUrl: string;
  mexicoDisable: boolean = false;
  platformId = inject(PLATFORM_ID);
  CoreSearchForm!: FormGroup;
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  private destroy$ = new Subject<void>();

  constructor(private breakpointObserver: BreakpointObserver,
    private cdr: ChangeDetectorRef,
    private openDialog: MatDialog,
    private fb: FormBuilder,
    private serviceEnd: CoreLookUpService,
    private regService: RegisterService,
    private globalMessage: GlobalMessageService,
    private viewPortScroller: ViewportScroller,
    private endPointService: OccEndpointsService,
    private route: Router,
    private router: ActivatedRoute
  ) {
    this.currentUrl = isPlatformBrowser(this.platformId) ? window.location.href : '';
    if (this.currentUrl.includes('MX')) {
      this.mexicoDisable = true;
    }
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .pipe(takeUntil(this.destroy$)).subscribe((result) => {
        this.isMobile = result.matches;
        this.isMobile = result.matches;
        if (this.isMobile) {
          this.widthPercentage = 87;
        }
      });
    this.baseUrl = this.endPointService.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }
  coreReturnRequest = new FormGroup({
    coreDate: new FormControl(''),
    coreReturnMonth: new FormControl(''),
    customerCRNumber: new FormControl(''),
    customerCRMNumber: new FormControl(''),
    soldToCode: new FormControl(''),
    anotherCRM: new FormControl('YES'),
    crmList: new FormControl(''),
    addressCompanySoldto: new FormControl('', { validators: [Validators.required] }),
    addressSoldto: new FormControl('', { validators: [Validators.required] }),
    address2Soldto: new FormControl(''),
    citySoldto: new FormControl('', { validators: [Validators.required] }),
    zipCodeSoldto: new FormControl('', { validators: [Validators.required] }),
    stateSoldto: new FormControl('', { validators: [Validators.required] }),
    countryISOSoldto: new FormControl(null, { validators: [Validators.required] }),
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    phone: new FormControl('', { validators: [Validators.required] }),
    emailAddress: new FormControl('', { validators: [Validators.required] }),
    warrantyMaterial: new FormControl(false),
    warrantyClaimNo: new FormControl(''),
    kbTransport: new UntypedFormControl('true'),
    kbCoreSubmissionAddressForm: new FormGroup({
      b2BUnit: new FormControl(null),
      newAddress: new FormControl(false),
      addressCompanyNew: new FormControl('', { validators: [Validators.required] }),
      addressNew: new FormControl(''),
      address2New: new FormControl(''),
      cityNew: new FormControl('', { validators: [Validators.required] }),
      zipCodeNew: new FormControl('', { validators: [Validators.required] }),
      townNew: new FormControl(null, { validators: [Validators.required] }),
      countryISONew: new FormControl(null, { validators: [Validators.required] }),
      addressCompany: new FormControl('', { validators: [Validators.required] }),
      address: new FormControl('', { validators: [Validators.required] }),
      address2: new FormControl(''),
      city: new FormControl('', { validators: [Validators.required] }),
      zipCode: new FormControl('', { validators: [Validators.required] }),
      state: new FormControl('', { validators: [Validators.required] }),
      countryISO: new FormControl(null, { validators: [Validators.required] }),
      addressFName: new FormControl(''),
      addressLName: new FormControl(''),
      addressPhone: new FormControl(''),
      addressEmail: new FormControl(''),
      productType: new FormControl(null, { validators: [Validators.required] }),
      weight: new FormControl(0.0),
      size: new FormControl(0),
    }),
    packageType: new FormControl('PALLET'),
    packageQty: new FormControl('', { validators: [Validators.required] }),
    totalWeight: new FormControl(0.0),
    totalQty: new FormControl(0),
    coreRows: new FormControl(0),
    actualWeight: new FormControl(0.0),
    coreLineItems: this.fb.array([]),
    finalSubmit: new FormControl(false),
    finalReview: new FormControl(false),
    finalSave: new FormControl(false),
    certifycheck: new FormControl(false),
    coreAddInvoiceNumber: this.fb.array([])
  });

  dynamicTableForm() {
    return new FormGroup({
      coreGroup: new FormControl(this.mexicoDisable ? { value: null, disabled: true } : null, { validators: [Validators.required] }),
      coreGrade: new FormControl(this.mexicoDisable ? { value: null, disabled: true } : null, { validators: [Validators.required] }),
      coreClass: new FormControl(this.mexicoDisable ? { value: null, disabled: true } : null, { validators: [Validators.required] }),
      coreClassDescription: new FormControl(null),
      coreGroupDescription: new FormControl(null),
      corePartNumber: new FormControl({ value: null, disabled: true }),
      updateCoreGroup: new FormControl(this.mexicoDisable ? { value: null, disabled: true } : null,),
      itemQty: new FormControl(this.mexicoDisable ? { value: null, disabled: true } : null, { validators: [Validators.required] }),
      submissionUpgrade: new FormControl(false),
      weightAprox: new FormControl(0.0),
      itemWeight: new FormControl(0.0),
      deletecheckbox: new FormControl(false),
    })
  }
  get dtf() {
    return this.coreReturnRequest.get('coreLineItems') as FormArray;
  }
  // ✅ Getter for easy access in HTML
  get invoiceNumberFormArray(): FormArray {
    return this.CoreSearchForm.get('coreAddInvoiceNumber') as FormArray;
  }

  get invoiceControls(): FormGroup[] {
    return (this.coreReturnRequest?.get('coreAddInvoiceNumber') as FormArray)?.controls as FormGroup[];
  }
  get nestedForm() {
    return this.coreReturnRequest.get('kbCoreSubmissionAddressForm') as FormGroup;
  }
  get coreForm() {
    return this.coreReturnRequest.controls;
  }
  getcoreLineEMEAControls(index: number, controlName: string): any {
    return this.coreReturnRequest.get('coreLineItems').get(index.toString()).get(controlName);
  }
  ngOnInit() {
    if (this.mexicoDisable) {
      this.coreForm.phone.clearValidators();
      this.coreForm.kbCoreSubmissionAddressForm.get('addressCompany').clearValidators();
      this.coreForm.kbCoreSubmissionAddressForm.get('address').clearValidators();
      this.coreForm.kbCoreSubmissionAddressForm.get('address2').clearValidators();
      this.coreForm.kbCoreSubmissionAddressForm.get('city').clearValidators();
      this.coreForm.kbCoreSubmissionAddressForm.get('zipCode').clearValidators();
      this.coreForm.kbCoreSubmissionAddressForm.get('state').clearValidators();
      this.coreForm.kbCoreSubmissionAddressForm.get('countryISO').clearValidators();
      this.coreForm.kbCoreSubmissionAddressForm.get('productType').clearValidators();
    }
    if (this.isMobile) {
      this.setCustomWidth();
    }

    this.router.queryParams.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data.claimNo) {
        this.serviceEnd.getSavedCoreDetails(data.claimNo).pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.initializeForm(data);
        })
      } else {
        this.initializeForm();
      }
    })

    this.serviceEnd.addCoreFormData.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data) {
        this.openDialog.closeAll();
        if (!this.selectedPopupIndex) {
          this.selectedPopupIndex = 0;
        }
        if (this.coreReturnRequest.get('coreLineItems')['controls'].length == 0) {
          this.addPartNumber();
        }
        const formArray = this.coreReturnRequest.get('coreLineItems') as FormArray;
        const formGroup = formArray.at(this.selectedPopupIndex) as FormGroup;;
        Object.keys(formGroup.controls).forEach(controlName => {
          formGroup.get(controlName).enable();
        });
        this.coreReturnRequest.get('coreLineItems')['controls'][this.selectedPopupIndex].controls['coreGroup'].setValue(data.coreGroup);
        this.getCoreClass(this.selectedPopupIndex, data.coreGroup, data.coreClass, data.code, data.coreClassDescription, data.coreClassDescription);
      }
    })
  }
  // ✅ Create single FormGroup
  createInvoiceGroup(): FormGroup {
    return this.fb.group({
      invoiceNumber: ['']
    });
  }
  // ✅ Add new invoice field
  addInvoiceField(): void {
    const invoiceArray = this.coreReturnRequest.get('coreAddInvoiceNumber') as FormArray;
    invoiceArray.push(this.createInvoiceGroup());
  }
  // ✅ (Optional) remove field if needed
  removeInvoiceField(index: number): void {
    if (this.invoiceNumberFormArray.length > 1) {
      this.invoiceNumberFormArray.removeAt(index);
    }
  }
  initializeForm(coreData?: any) {
    this.regService.getRegisterPageFields().subscribe((res: any) => {
      this.countryDataArray = res?.countriesWSList;
    });
    this.serviceEnd.getcoresubmit().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.Apidata = data;
      this.autoGenerateCustId(data?.currentB2BUnitWS?.uid);
      this.loopingCustomerId(data?.currentB2BUnitWS?.uid);
      this.apiloaded = true;
      if (this.coreReturnRequest.get('coreLineItems')['controls'].length == 0) {
        this.addPartNumber();
      }
      this.downLoadUrl = this.baseUrl + data?.mediaUrl;
      this.coreForm.coreDate.setValue(data?.coreDate);
      this.coreForm.customerCRMNumber.setValue(data?.coreGroupsNa?.coreReturnNumber);
      this.coreForm.coreReturnMonth.setValue(data?.coreReturnMonth);
      this.coreForm.firstName.setValue(data?.customer?.firstName);
      this.coreForm.lastName.setValue(data?.customer?.lastName);
      this.coreForm.emailAddress.setValue(data?.customer?.displayUid);
      this.upgradeCheckbox(0);
      this.productTypeArray = this.Apidata?.coreProductTypes?.entry;
      const invoiceArray = this.coreReturnRequest.get('coreAddInvoiceNumber') as FormArray;
      invoiceArray.clear();
      if (data?.invoiceNumbers?.length) {
        data.invoiceNumbers.forEach((inv: any) => {
          invoiceArray.push(
            this.fb.group({
              invoiceNumber: [inv]
            })
          );
        });
      } else {
        invoiceArray.push(this.createInvoiceGroup());
      }
      if (this.mexicoDisable) {
        const defaultItem = this.productTypeArray.find(item => item.key === 'ANY')
        if (defaultItem) {
          this.nestedForm.get('productType').setValue(defaultItem.key)
        }
      }
      if (coreData) {
        this.coreForm.coreDate.setValue(coreData?.coreDate);
        this.coreForm.customerCRNumber.setValue(coreData?.crmNumber);
        this.coreForm.customerCRMNumber.setValue(coreData?.customerCRNumber);
        this.coreForm.coreReturnMonth.setValue(coreData?.coreReturnMonth);
        this.coreForm.firstName.setValue(coreData?.firstName);
        this.coreForm.lastName.setValue(coreData?.lastName);
        this.coreForm.emailAddress.setValue(coreData?.emailAddress);
        this.coreForm.phone.setValue(coreData?.phone);
        this.coreForm.kbTransport.setValue(coreData?.kbTransport + "");
        this.coreForm.packageQty.setValue(coreData?.packageQty);
        this.coreForm.packageType.setValue(coreData?.packageType);
        this.coreForm.totalQty.setValue(coreData?.totalQty);
        this.coreForm.totalWeight.setValue(coreData?.totalWeight);
        this.coreForm.warrantyMaterial.setValue(coreData?.warrantyMaterial);

        const controls = this.coreReturnRequest.get('kbCoreSubmissionAddressForm') as FormGroup;
        controls.get('newAddress').setValue(coreData?.kbCoreSubmissionAddressForm?.newAddress);
        if (!coreData?.kbCoreSubmissionAddressForm?.newAddress) {
          controls.get('addressCompany').setValue(coreData?.kbCoreSubmissionAddressForm?.addressCompany);
          controls.get('address').setValue(coreData?.kbCoreSubmissionAddressForm?.address);
          controls.get('address2').setValue(coreData?.kbCoreSubmissionAddressForm?.line2);
          controls.get('city').setValue(coreData?.kbCoreSubmissionAddressForm?.city);
          controls.get('zipCode').setValue(coreData?.kbCoreSubmissionAddressForm?.zipCode);
          controls.get('countryISO').setValue(coreData?.kbCoreSubmissionAddressForm?.countryISO);
          controls.get('state').setValue(coreData?.kbCoreSubmissionAddressForm?.townNew);
          controls.get('b2BUnit').setValue(coreData?.kbCoreSubmissionAddressForm?.b2BUnit);
          controls.get('productType').setValue(coreData?.kbCoreSubmissionAddressForm?.productType);
        } else {
          controls.get('addressCompanyNew').setValue(coreData?.kbCoreSubmissionAddressForm?.addressCompany);
          controls.get('addressNew').setValue(coreData?.kbCoreSubmissionAddressForm?.address);
          controls.get('address2New').setValue(coreData?.kbCoreSubmissionAddressForm?.address2);
          controls.get('cityNew').setValue(coreData?.kbCoreSubmissionAddressForm?.city);
          controls.get('zipCodeNew').setValue(coreData?.kbCoreSubmissionAddressForm?.zipCode);
          controls.get('countryISONew').setValue(coreData?.kbCoreSubmissionAddressForm?.countryISO);
          this.getStatelist(coreData?.kbCoreSubmissionAddressForm?.townNew, controls);
        }


        let totalRows = 1;
        coreData.coreLineItems.forEach((item, index) => {
          this.getcoreLineEMEAControls(index, 'coreGroup').setValue(item.coreGroup);
          this.serviceEnd.getmycorecoreclass(item.coreGroup).pipe(takeUntil(this.destroy$)).subscribe((coreClass: any) => {
            this.coreClass[index] = coreClass?.coreClasses?.entry;
            this.getcoreLineEMEAControls(index, 'coreClass').setValue(item.coreClass);
            this.getcoreLineEMEAControls(index, 'coreGrade').setValue(item.coreGrade);
            this.getcoreLineEMEAControls(index, 'updateCoreGroup').setValue(item.updateCoreGroup);
            this.cdr.detectChanges();
          })

          this.serviceEnd.getmycoreweightna(item.coreClass).pipe(takeUntil(this.destroy$)).subscribe((weight: any) => {
            const res = weight?.weight;
            this.getcoreLineEMEAControls(index, 'weightAprox').setValue(res);
            this.getcoreLineEMEAControls(index, 'itemQty').setValue(item.itemQty);
            this.getcoreLineEMEAControls(index, 'itemWeight').setValue(item.itemWeight);
            this.weightCalculator();

          });
          if (totalRows < coreData.coreLineItems.length) {
            this.addPartNumber();
          }
          totalRows += 1;
        })
      }
      this.cdr.detectChanges();
    });
  }



  upgradeCheckbox(index: number) {
    if (!this.getcoreLineEMEAControls(index, 'submissionUpgrade').value) {
      this.getcoreLineEMEAControls(index, 'updateCoreGroup').disable();
    } else {
      this.getcoreLineEMEAControls(index, 'updateCoreGroup').enable();
    }
  }
  getAddressesonCustIdChange(code) {
    this.serviceEnd.getmycorepopulateAddressSelect(code).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.addressListArray = data?.addressList;
      this.autoGenerateCustId(code);
      if (this.dataFrom && data.addressList) {
        this.nestedForm.get('b2BUnit').setValue(data?.addressList[0].pk);
        this.autoGenerate();
      } else {
        this.dataFrom = false;
      }

      this.cdr.detectChanges();
    })
  }
  loopingCustomerId(selectedUid: string) {
    this.coreForm.soldToCode.patchValue(selectedUid);
    this.getAddressesonCustIdChange(selectedUid);
  }
  getkbCoreAddressItems(index: number, controlName: string): any {
    const nestedGroup = this.coreReturnRequest.get('kbCoreSubmissionAddressForm') as FormGroup;
    return nestedGroup.get('kbCoreAddressItems').get(index.toString()).get(controlName);
  }
  get nestedFormGroup() {
    return this.coreReturnRequest.get('kbCoreSubmissionAddressForm') as FormGroup;
  }
  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = window.innerWidth - 10;
      document.documentElement.style.setProperty('--custom-table-width', `${widthInPixels}px`);
    }
  }
  autoGenerate() {
    const addressForm = this.coreReturnRequest.get('kbCoreSubmissionAddressForm') as FormGroup;
    const selectedValue = addressForm.get('b2BUnit').value;
    this.addressListArray.find((x: any) => {
      if (x.pk == selectedValue) {
        addressForm.get('addressCompany').setValue(x?.companyName);
        addressForm.get('address').setValue(x?.line1);
        addressForm.get('address2').setValue(x?.line2);
        addressForm.get('state').setValue(x?.region?.name);
        addressForm.get('zipCode').setValue(x?.postalCode);
        addressForm.get('countryISO').setValue(x?.country?.isocode);
        addressForm.get('city').setValue(x?.town);
      }
    })

  }


  autoGenerateCustId(selectedUid?: string) {
    const uid = selectedUid || this.coreForm.soldToCode.value;

    if (!this.Apidata?.b2bUnitsWSListNa?.length) return;

    // ✅ Step 1: find matching unit using uid
    const selectedUnit = this.Apidata.b2bUnitsWSListNa.find(
      (x: any) => x.uid == uid
    );

    if (!selectedUnit) return;

    // ✅ Step 2: get first address
    const address = selectedUnit.addresses?.[0];

    if (!address) return;

    // ✅ Step 3: bind values
    this.coreForm.addressCompanySoldto.setValue(address?.companyName || selectedUnit?.name);
    this.coreForm.addressSoldto.setValue(address?.line1);
    this.coreForm.address2Soldto.setValue(address?.line2);
    this.coreForm.stateSoldto.setValue(address?.region?.name);
    this.coreForm.zipCodeSoldto.setValue(address?.postalCode);
    this.coreForm.countryISOSoldto.setValue(address?.country?.isocode);
    this.coreForm.citySoldto.setValue(address?.town);
  }
  getStatelist(state?, controls?) {
    const code = this.nestedForm.get('countryISONew').value;
    this.regService.getRegions(code).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.stateDataArray = res.regionsWSList;
      if (state) {
        controls.get('townNew').setValue(state);
      }
      this.cdr.detectChanges();
    })
  }

  receiveData(data: any) {
    this.showChild = false;
    this.dataFrom = true;
    this.loopingCustomerId(data);
  }
  getCoreClass(index: number, coreGroup?: string, coreClassVal?: string, partNo?: string, coreGroupDescription?: string, coreClassDescription?: string) {
    let code;
    if (coreGroup) {
      code = coreGroup
    } else {
      code = this.getcoreLineEMEAControls(index, 'coreGroup').value;
    }

    this.serviceEnd.getmycorecoreclass(code).pipe(takeUntil(this.destroy$)).subscribe((coreClass: any) => {
      this.coreClass[index] = coreClass?.coreClasses?.entry;
      this.getcoreLineEMEAControls(index, 'coreGrade').reset();
      this.getcoreLineEMEAControls(index, 'updateCoreGroup').reset();
      this.getcoreLineEMEAControls(index, 'weightAprox').reset();
      if (coreGroup) {
        setTimeout(() => {
          this.coreReturnRequest.get('coreLineItems')['controls'][this.selectedPopupIndex].controls['coreClass'].setValue(coreClassVal);
        }, 100);
        this.getcoreLineEMEAControls(index, 'coreGroupDescription').setValue(coreGroupDescription)
        this.getcoreLineEMEAControls(index, 'coreClassDescription').setValue(coreClassDescription)
        this.getcoreLineEMEAControls(index, 'corePartNumber').disable()
        this.getcoreLineEMEAControls(index, 'corePartNumber').setValue(partNo)
        this.getUpgradeCoreClass(index);
        this.getcoreLineEMEAControls(index, 'updateCoreGroup').disable();
        this.getWeightNa(this.selectedPopupIndex, coreClassVal);
      }
      this.cdr.detectChanges();
    });
  }
  getWeightNa(index: number, coreClass?: string) {
    let code;
    if (coreClass) {
      code = coreClass
    } else {
      code = this.getcoreLineEMEAControls(index, 'coreClass').value;
    }
    this.serviceEnd.getmycoreweightna(code).pipe(takeUntil(this.destroy$)).subscribe((weight: any) => {
      const res = weight?.weight;
      this.getcoreLineEMEAControls(index, 'weightAprox').setValue(res);
      this.weightCalculator();
    });
  }

  getUpgradeCoreClass(index: number) {
    const code = this.getcoreLineEMEAControls(index, 'coreClass').value;
    this.serviceEnd.getmyupgradecorecoreclass(code).pipe(takeUntil(this.destroy$)).subscribe((coreUpgradeClass: any) => {
      if (coreUpgradeClass.coreUpdateGroup?.entry) {
        this.coreUpgradeClass[index] = coreUpgradeClass?.coreUpdateGroup?.entry;
      } else {
        const val =
          [{ key: "NA", value: "NA" }]
        this.coreUpgradeClass[index] = val;
      }

      if (coreUpgradeClass && this.selectedPopupIndex) {
        this.coreReturnRequest.get('coreLineItems')['controls'][this.selectedPopupIndex].controls['updateCoreGroup'].setValue(coreUpgradeClass);
      }
      this.cdr.detectChanges();
    });
  }

  onKeyDown(event: KeyboardEvent): void {
    const isDigit = event.key >= '0' && event.key <= '9';
    const isControlKey = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(event.key);

    if (!isDigit && !isControlKey) {
      event.preventDefault();
    }
  }

  weightCalculator(index?: number, event?: any) {
    const coreLineArray = this.dtf.controls;
    let totalWeightCalc = 0;
    let totalQty = 0;
    for (let i = 0; i < coreLineArray.length; i++) {
      const qty = Number(coreLineArray[i].get('itemQty').value) || 0;
      const weightAprox = parseFloat(coreLineArray[i].get('weightAprox').value) || 0;
      const lineitemTotalWeight = qty * weightAprox;
      coreLineArray[i].get('itemWeight').setValue(Math.round((lineitemTotalWeight + Number.EPSILON) * 100) / 100);
      totalWeightCalc += lineitemTotalWeight;
      totalQty += qty;
    }
    this.coreForm.totalWeight.setValue(Math.round((totalWeightCalc + Number.EPSILON) * 100) / 100);
    this.coreForm.totalQty.setValue(Number(totalQty));

  }

  toggleTextBox() {
    this.showTextBox = !this.showTextBox;
  }
  underRadio500lbs() {
    const radiobuttonState = this.coreForm.kbTransport.value;
    const addressForm = this.coreReturnRequest.get('kbCoreSubmissionAddressForm') as FormGroup;
    if (radiobuttonState == 'false') {
      this.transportNeeded = true;
      addressForm.disable();
      this.showUnder500 = false;
      this.coreForm.packageType.setValue('BOX');
      this.notDisplay = true;
    }
    else {
      this.showUnder500 = false;
      addressForm.enable();
      this.showUnder500 = true;
      this.notDisplay = false;
      this.coreForm.packageType.setValue('PALLET');

    }
    this.cdr.detectChanges();

  }
  addPartNumber() {
    this.dtf.push(this.dynamicTableForm());
    if (this.dtf?.controls && this.dtf.controls.length > 1) {
      this.upgradeCheckbox(this.dtf.controls.length - 1);
    }
  }
  removePartInfo(i) {
    this.dtf.removeAt(i);

  }
  //function for deleting one row
  removeField(index: number) {
    const formArray = this.coreReturnRequest.get('coreLineItems') as FormArray;
    if (formArray.length > 1) {
      formArray.removeAt(index);
      this.coreClass.splice(index,1);
      this.coreUpgradeClass.splice(index,1);
    }

    // if (formArray.length <= 0) {
    //   this.addPartNumber();
    // }
    this.weightCalculator();
    this.cdr.detectChanges();
  }
  //function for deleting rows selected checkboxes
  removeSelectedRows() {
    const formArray = this.coreReturnRequest.get('coreLineItems') as FormArray;
    for (let i = formArray.length - 1; i >= 0; i--) {
      const checkboxControl = formArray.at(i).get('deletecheckbox') as FormControl;
      if (checkboxControl?.value && formArray.length > 1) {
        formArray.removeAt(i);
        this.coreClass.splice(i,1);
       this.coreUpgradeClass.splice(i,1);
      }
    }
    // if (formArray.length <= 0) {
    //   this.addPartNumber();
    // }
    this.weightCalculator();
    this.cdr.detectChanges();
  }
  selectAllRows(event: any) {
    const formArray = this.coreReturnRequest.get('coreLineItems') as FormArray;
    const isTopCheckboxSelected = event.target.checked;
    formArray.controls.forEach((control: FormGroup) => {
      const checkboxControl = control.get('deletecheckbox');
      checkboxControl?.setValue(isTopCheckboxSelected);
      this.cdr.detectChanges();
    });

  }

  finalReview() {
    this.errorMsgList = null;
    this.coreReturnRequest.markAllAsTouched();
    this.coreForm.finalReview.setValue(true);
    this.coreForm.finalSave.setValue(false);
    this.coreForm.finalSubmit.setValue(false);
    this.coreForm.customerCRNumber.setValue(this.coreForm.customerCRMNumber.value);
    this.beforeSubmit();
    this.savedSuccessfully = false;
    if (this.coreReturnRequest.valid) {

      this.isFormContainsError = false;
      this.serviceEnd.postcoreSubmitForm(this.coreReturnRequest.getRawValue()).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        if (res?.kbStatusMessageWSDTO?.status == "error") {
          this.globalMessage.add(res?.kbStatusMessageWSDTO?.message, GlobalMessageType.MSG_TYPE_ERROR);
          this.isFormContainsError = true;
          this.viewPortScroller.scrollToPosition([0, 150]);
          this.cdr.detectChanges();
        } else {
          this.isFormFilledSuccessfully = true;
          this.isFormContainsError = false;
          this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
          this.viewPortScroller.scrollToPosition([0, 150]);
          this.cdr.detectChanges();
        }

      });

    } else {
      this.viewPortScroller.scrollToPosition([0, 150]);
      this.isFormContainsError = true;
    }
  }
  beforeSubmit() {
    const controls = this.coreReturnRequest.get('kbCoreSubmissionAddressForm') as FormGroup;
    const checkboxState = controls.get('newAddress').value;
    if (checkboxState == true) {
      controls.get('addressCompany').disable();
      controls.get('address').disable();
      controls.get('address2').disable();
      controls.get('city').disable();
      controls.get('zipCode').disable();
      controls.get('countryISO').disable();
      controls.get('state').disable();
      controls.get('addressCompanyNew').enable();
      controls.get('addressNew').enable();
      controls.get('address2New').enable();
      controls.get('cityNew').enable();
      controls.get('zipCodeNew').enable();
      controls.get('countryISONew').enable();
      controls.get('townNew').enable();

    } else {

      controls.get('addressCompanyNew').disable();
      controls.get('addressNew').disable();
      controls.get('address2New').disable();
      controls.get('cityNew').disable();
      controls.get('zipCodeNew').disable();
      controls.get('countryISONew').disable();
      controls.get('townNew').disable();
    }
  }
  saveforlater() {
    this.errorMsgList = null;
    this.coreForm.finalReview.setValue(false);
    this.coreForm.finalSave.setValue(true);
    this.coreForm.finalSubmit.setValue(false);
    this.beforeSubmit();
    if (this.coreReturnRequest.valid) {
      this.isFormContainsError = false;
      this.serviceEnd.postcoreSubmitForm(this.coreReturnRequest.getRawValue()).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.savedSuccessfully = true;
        this.coreForm.customerCRNumber.setValue(res?.crmNumber);
        // this.newFileSend();
        this.isFormFilledSuccessfully = true;
        this.cdr.detectChanges();
      });
    } else {
      this.isFormContainsError = true;
    }
  }
  openPopup() {
    const popup = this.coreForm.kbTransport.value;
    if (popup == 'false') {
      this.onSubmit();
    }
    else {
      this.openDialog.open(this.confirmSubmitPopup);
    }

  }
  onSubmit() {
    if (this.coreReturnRequest.valid) {
      this.errorMsgList = null;
      const coreReturnReqCopy = this.coreReturnRequest;
      if (this.coreForm.kbTransport.value == false) {
        this.coreForm.kbTransport.setValue('false');
      }
      if (this.coreForm.kbTransport.value == true) {
        this.coreForm.kbTransport.setValue('true');
      }
      if (this.coreForm.kbTransport.value == 'true') {
        this.coreForm.kbTransport.setValue(true);
        const addressForm = coreReturnReqCopy.get('kbCoreSubmissionAddressForm') as FormGroup;
        addressForm.enable();
        addressForm.get('weight').setValue(0.0);

      } else {
        this.coreForm.kbTransport.setValue(false);
      }

      const reqPayload: any = this.coreForm.kbTransport.value ? coreReturnReqCopy.getRawValue() : this.coreReturnRequest.getRawValue();

      this.beforeSubmit();
      const data = this.coreReturnRequest.getRawValue();
      reqPayload.finalReview = false;
      reqPayload.finalSave = false;
      reqPayload.finalSubmit = true;
      reqPayload.anotherCRM = 'NO';
      reqPayload.crmList = this.crmStaticKepper;
      reqPayload.customerCRNumber = data.customerCRMNumber;
      reqPayload.kbTransport = this.coreForm.kbTransport.value;
      // ✅ ✅ ADD THIS BLOCK (invoice transformation)
      const invoiceArrayControl = this.coreReturnRequest.get('coreAddInvoiceNumber') as FormArray;
      const invoiceNumberPayload = invoiceArrayControl.value
        .filter((item: any) => item.invoiceNumber)
        .map((item: any) => item.invoiceNumber);
      reqPayload.invoiceNumber = invoiceNumberPayload;
      delete reqPayload.coreAddInvoiceNumber;
      // ✅ ✅ END
      this.serviceEnd.postcoreSubmitForm(reqPayload).subscribe((res: any) => {
        this.isFormContainsError = false;
        this.savedSuccessfully = false;
        this.submittedSuccessFully = true;
        this.barCodeLabel = res?.barCodeLabel;
        this.coreForm.customerCRNumber.setValue(res?.crmNumber);
        if (this.coreForm.kbTransport.value == true) {
          this.coreForm.kbTransport.setValue('true');
        } else {
          this.coreForm.kbTransport.setValue('false');
        }



        this.coreReturnRequest.disable();
        this.viewPortScroller.scrollToPosition([0, 150]);
        this.cdr.detectChanges();
      });
    }
    else {
      this.coreReturnRequest.markAllAsTouched();
      this.isFormContainsError = true;
      this.isFormFilledSuccessfully = false;
      this.timeout = setTimeout(() => {
        this.viewPortScroller.scrollToPosition([0, 150]);
      }, 1000);
      this.cdr.detectChanges();

    }

  }
  newFileSend(file) {
    const fileData = new FormData();
    this.errorMsgList = null;
    fileData.append('csvFile', file);
    this.serviceEnd.FilePostApi(fileData).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      if (x?.errorMessages.length > 0) {
        this.errorMsgList = x?.errorMessages;
      }
      if (x?.message?.status == 'SUCCESS') {
        this.fileUploadMsg = x?.message?.message;
      }
      file = '';
      this.cdr.detectChanges();
    });
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    let index = 0;
    if (this.coreReturnRequest.get('coreLineItems')['controls']?.length > 1) {
      index = this.coreReturnRequest.get('coreLineItems')['controls']?.length;
      this.addPartNumber();
    }

    if (file) {
      this.newFileSend(file);
      this.processCsv(file).pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          this.coreClass[index] = response[0]?.coreClasses?.entry;
          this.getcoreLineEMEAControls(index, 'coreGrade').reset();
          this.getcoreLineEMEAControls(index, 'updateCoreGroup').reset();
          this.getcoreLineEMEAControls(index, 'weightAprox').reset();
          const res = response[1]?.weight;
          this.getcoreLineEMEAControls(index, 'weightAprox').setValue(res);

          let coreGrade = response[2][CORE_GRADE];
          if (response[2][CORE_GRADE].toLowerCase().indexOf('good') > -1) {
            coreGrade = "GC";
          }
          if (response[2][CORE_GRADE].toLowerCase().indexOf('part') > -1) {
            coreGrade = "PD";
          }
          if (response[2][CORE_GRADE].toLowerCase().indexOf('parts') > -1) {
            coreGrade = "PSD";
          }
          if (response[2][CORE_GRADE].toLowerCase().indexOf('scra') > -1) {
            coreGrade = "SC";
          }
          if (response[2][CORE_GRADE].toLowerCase().indexOf('know') > -1) {
            coreGrade = "DN";
          }

          const coreGroupIndex = this.Apidata?.coreGroupsNa?.entry?.findIndex(role => role.key === response[2][CORE_GROUP]);
          if (coreGroupIndex > -1) {
            this.getcoreLineEMEAControls(index, 'coreGroup').setValue(response[2][CORE_GROUP]);
          }

          const i = this.coreClass[index]?.findIndex(role => role.key === response[2][CORE_CLASS]);
          if (i > -1) {
            this.getcoreLineEMEAControls(index, 'coreClass').setValue(response[2][CORE_CLASS]);
          }

          const coreGradeIndex = this.Apidata?.coreGrade?.entry?.findIndex(role => role.key === coreGrade);
          if (coreGradeIndex > -1) {
            this.getcoreLineEMEAControls(index, 'coreGrade').setValue(coreGrade);
          }

          this.getcoreLineEMEAControls(index, 'itemQty').setValue(response[2]['Qty*']);
          this.weightCalculator();
          if (index < this.csvFileListLength - 1) {
            this.addPartNumber();
          }
          index += 1;
          event.target.value = null;
          this.cdr.detectChanges();
        },
        error => {
          console.error('Error:', error);
        }
      );
    }
  }


  processCsv(file: File): Observable<any> {
    return this.parseCsv(file).pipe(
      mergeMap((dataArray: any[]) => {
        return from(dataArray).pipe(
          // Filter out empty rows or rows without the necessary fields
          filter(data => data[CORE_GROUP] && data[CORE_CLASS] && data[CORE_GRADE] && data['Qty*']),
          mergeMap(data => this.makeHttpCall(data))
        );
      })
    );
  }

  /* parseCsv(file: File): Observable<any> {
    return new Observable(observer => {
      Papa.parse(file, {
        header: true,
        complete: (result) => {
          observer.next(result.data);
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
        }
      });
    });
  } */
  parseCsv(file: File): Observable<any> {
    return new Observable((observer) => {
      const reader = new FileReader();

      reader.onload = () => {
        try {
          // Ensure we have UTF-8 text even if the file has a BOM
          const text =
            typeof reader.result === 'string'
              ? reader.result
              : new TextDecoder('utf-8').decode(reader.result as ArrayBuffer);

          // Equivalent to Papa.parse with { header: true }
          parse(
            text,
            {
              columns: true,          // first row becomes object keys
              skip_empty_lines: true, // ignore blank rows
              trim: true,             // optional: trims each cell
            },
            (err, records /* Array<object> */) => {
              if (err) {
                observer.error(err);
              } else {
                observer.next(records);
                observer.complete();
              }
            }
          );
        } catch (e) {
          observer.error(e);
        }
      };

      reader.onerror = () => observer.error(reader.error);
      // Read as ArrayBuffer then decode — more robust for BOM/encodings
      reader.readAsArrayBuffer(file);
    });
  }

  makeHttpCall(data: any): any {
    this.csvFileListLength += 1;
    // Assuming the field you want to use for HTTP call is `fieldValue`
    return combineLatest([this.serviceEnd.getmycorecoreclass(data[CORE_GROUP]), this.serviceEnd.getmycoreweightna(data["Core Class*"]), of(data)])
  }


  openPopups(index) {
    this.selectedPopupIndex = index;
    this.openDialog.open(CoreDialogComponent, { width: '92vw', maxHeight: '90vh', panelClass: 'core-dialog-comp' });
  }


  createForm() {
    this.coreForm.anotherCRM.setValue('YES');
    const payLoadCopy = this.coreReturnRequest.value;


    payLoadCopy.crmList = this.crmStaticKepper;
    payLoadCopy.kbTransport = this.coreForm.kbTransport.value;
    if (this.coreReturnRequest.valid) {
      this.isFormContainsError = false;
      payLoadCopy.finalReview = false;
      payLoadCopy.customerCRNumber = this.coreForm.customerCRMNumber.value;
      this.serviceEnd.postcoreSubmitForm(payLoadCopy).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.coreForm.customerCRNumber.setValue(res?.crmNumber);
        this.coreForm.crmList.setValue(res?.crmNumber);

        this.isFormFilledSuccessfully = false;
        this.showUnder500 = true;
        this.UserCrmForm = false;
        this.notDisplay = true;
        this.coreForm.actualWeight.setValue(0.0);
        this.coreForm.packageQty.reset();
        this.coreReturnRequest.get('kbCoreSubmissionAddressForm')?.get('productType')?.disable();
        this.coreForm.kbTransport.disable();
        this.coreForm.totalQty.reset();
        this.coreForm.totalWeight.reset();
        this.coreReturnRequest.get('coreLineItems').reset();
        this.dtf.controls.length = 1;


        if (this.crmStaticKepper.length === 0) {
          this.crmStaticKepper += this.coreForm.crmList.value;

        } else {
          this.crmStaticKepper += "," + this.coreForm.crmList.value;
        }
        this.cdr.detectChanges();
      });
    } else {
      this.isFormContainsError = true;
    }
  }

  redirectCoreGroup() {
    this.route.navigate(['CoreInfoCenter']);
  }

  clickHere() {
    this.route.navigate(['search-coreReturn']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.serviceEnd.addCoreFormData.next(null);
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

}

